import { createContext } from '@lit/context';
import { Filters } from '../util/filter-sort';

export const filtersContext = createContext<Filters>(Symbol('filters'));
